/* assets/honto-link.js */
(function () {
  var PLACE = 'right'; // 'right' or 'below'（ログイン時のみ）
  var IMG_SRC = 'https://cdn.shopify.com/s/files/1/0858/8266/7312/files/icon_honto_ebooklink.webp?v=1759402901';
  var IMG_FALLBACK = 'https://cdn.shopify.com/s/files/1/0858/8266/7312/files/icon_honto_ebooklink.png?v=1759401735';

  // 表示サイズ・余白
  var IMG_HEIGHT_INLINE = 50; // ログイン時（ポイント行に並べる）
  var IMG_HEIGHT_BLOCK  = 50; // 未ログイン時（価格のすぐ下）
  var INLINE_GAP_PX     = 35; // ポイント行で右へ寄せる余白
  var PRICE_GAP_PX      = 6;  // 未ログイン時：価格直下の上マージン

  // ---- 環境判定 ----
  var UA = navigator.userAgent || '';
  // ── Bot 判定（レンダリングBot/プレビrun()run()ューBot 含む）
  var IS_BOT = (function () {
  var ua = (UA || '').toLowerCase();
    if (!ua) return false;
    return /bot|crawler|spider|crawling|googlebot|bingbot|yandex|baidu|duckduckbot|slurp|adsbot|mediapartners-google|facebookexternalhit|twitterbot|linkedinbot|applebot|pinterest|embedly|quora|whatsapp|telegrambot|discordbot|preview/i.test(ua);
  })();
  var IS_IOS = /(iPhone|iPad|iPod)/i.test(UA); // iOS は Safari/アプリ内WebView問わず _blank を明示
  var IS_ANDROID_WV = /Android/i.test(UA) && (/\bwv\)/i.test(UA) || /Version\/\d+.*Chrome\/\d+/i.test(UA)); // Android WebView

  function toIntentUrl(httpsUrl) {
    try {
      var u = new URL(httpsUrl);
      var scheme = u.protocol.replace(':', '');
      var fb = encodeURIComponent(httpsUrl);
      // browser_fallback_url を付与（Chromeが無い/Intent非対応時は外部で https を開く）
      return 'intent://' + u.host + u.pathname + (u.search || '') +
             '#Intent;scheme=' + scheme + ';package=com.android.chrome;S.browser_fallback_url=' + fb + ';end';
    } catch (_) { return null; }
  }

  function addPartnerId(u) {
    try {
      const x = new URL(u);
      if (!x.searchParams.has('partnerid')) {
        // 末尾に partnerid を追加
        x.searchParams.append('partnerid', 'mjnet_register');
      }
      return x.toString();
    } catch {
      // URL API が使えない/相対URLなどの保険（# があっても崩さない）
      if (/\bpartnerid=/.test(u)) return u;
      const i = u.indexOf('#');
      const base = i >= 0 ? u.slice(0, i) : u;
      const hash = i >= 0 ? u.slice(i) : '';
      return base + (base.includes('?') ? '&' : '?') + 'partnerid=mjnet_register' + hash;
    }
  }

  function createLink(isbn, finalUrl, heightPx) {
    var href = addPartnerId(finalUrl || ('https://honto.jp/isbn/' + isbn));

    var a = document.createElement('a');
    a.id = 'honto-ebook-link';
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener noreferrer external';
    a.style.display = 'inline-block';
    a.style.verticalAlign = 'middle';
    a.style.margin = '0';
    a.style.padding = '0';
    a.style.lineHeight = '1';

    var img = document.createElement('img');
    img.src = IMG_SRC;
    img.alt = 'hontoで電子版を見る';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.style.display = 'inline-block';
    img.style.height = heightPx + 'px';
    img.style.width = 'auto';
    img.style.border = '0';
    img.style.verticalAlign = 'middle';
    img.onerror = function () { if (img.src !== IMG_FALLBACK) img.src = IMG_FALLBACK; };
    a.appendChild(img);

    // --- iOS：常に _blank を明示実行（ページ内遷移回避） ---
    if (IS_IOS) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var w = null;
        try { w = window.open(href, '_blank'); } catch (_) {}
        if (!w) { location.href = href; } // 最終フォールバック
      }, { passive: false });
    }

    // --- Android WebView：intent:// で Chrome を起動。起動検知でフォールバックをキャンセル ---
    if (IS_ANDROID_WV) {
      a.addEventListener('click', function (e) {
        var intent = toIntentUrl(href);
        if (!intent) return; // 生成失敗なら通常動作（_blank）

        e.preventDefault();

        var fallbackTimer = setTimeout(function () {
          // まだ画面が隠れていなければ（= Chrome へ切り替わっていなければ）フォールバック
          if (document.visibilityState !== 'hidden') {
            try {
              var w = window.open(href, '_blank', 'noopener');
              if (!w) location.href = href; 
            } catch (_) {
              location.href = href;
            }
          }
        }, 800); // 端末差吸収

        function cancelFallback() {
          if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
          window.removeEventListener('visibilitychange', onVisibility, true);
          window.removeEventListener('pagehide', cancelFallback, true);
          window.removeEventListener('blur', cancelFallback, true);
        }
        function onVisibility() {
          if (document.visibilityState === 'hidden') cancelFallback();
        }

        window.addEventListener('visibilitychange', onVisibility, true);
        window.addEventListener('pagehide', cancelFallback, true);
        window.addEventListener('blur', cancelFallback, true);

        try { location.href = intent; } catch (_) {}
      }, { passive: false });
    }

    return a;
  }

  document.addEventListener('DOMContentLoaded', function() {
    const a_links = document.querySelectorAll('.detail-link');
    
    if (a_links.length === 0) return; 

    a_links.forEach(function(a) {
        const href = a.href; 
        
        // --- iOSのWebView対策ロジック ---
        if (typeof IS_IOS !== 'undefined' && IS_IOS) { 
            a.addEventListener('click', function (e) {
                e.preventDefault(); 
                var w = null;
                try { w = window.open(href, '_blank'); } catch (_) {} 
                if (!w) { location.href = href; } 
            }, { passive: false });
        }

        // --- Android WebView対策ロジック ---
        if (typeof IS_ANDROID_WV !== 'undefined' && IS_ANDROID_WV) { 
            a.addEventListener('click', function (e) {
                var intent = (typeof toIntentUrl === 'function') ? toIntentUrl(href) : null;
                if (!intent) return; 

                e.preventDefault();

                var fallbackTimer = setTimeout(function () {
                    if (document.visibilityState !== 'hidden') {
                        try {
                            var w = window.open(href, '_blank', 'noopener');
                            if (!w) location.href = href; 
                        } catch (_) {
                            location.href = href;
                        }
                    }
                }, 800); 

                function cancelFallback() {
                    if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
                    window.removeEventListener('visibilitychange', onVisibility, true);
                    window.removeEventListener('pagehide', cancelFallback, true);
                    window.removeEventListener('blur', cancelFallback, true);
                }
                function onVisibility() {
                    if (document.visibilityState === 'hidden') cancelFallback();
                }

                window.addEventListener('visibilitychange', onVisibility, true);
                window.addEventListener('pagehide', cancelFallback, true);
                window.addEventListener('blur', cancelFallback, true);

                try { location.href = intent; } catch (_) {}
            }, { passive: false });
        }
    }); 
});

  function findAddButton() {
    return (
      document.querySelector('form[action^="/cart/add"] [type="submit"][name="add"]') ||
      document.querySelector('.product-form [type="submit"][name="add"]') ||
      null
    );
  }

  // 価格ブロック直下に入れるためのアンカー
  function findPriceAnchor() {
    var el =
      document.querySelector('[id^="price-template"][id$="_main"] .price') ||
      document.querySelector('[id^="price-template"] .price') ||
      document.querySelector('product-info .price') ||
      document.querySelector('.product_info-container .price') ||
      document.querySelector('.price.price--large') ||
      document.querySelector('.price') ||
      document.querySelector('.product__price') ||
      document.querySelector('[data-product-price]') ||
      document.querySelector('.price__container') ||
      null;
    return el && el.closest ? (el.closest('.price') || el) : el;
  }

  function insertLink(isbn, finalUrl) {
    var pointRow = document.querySelector('.product_hontopoint');
    var pointBox = document.querySelector('.product_point-container');

    if (pointRow) {
      // ログイン時
      var a = createLink(isbn, finalUrl, IMG_HEIGHT_INLINE);
      if (PLACE === 'right') {
        pointRow.style.display = 'inline-flex';
        pointRow.style.alignItems = 'center';
        a.style.marginLeft = INLINE_GAP_PX + 'px';
        pointRow.appendChild(a);
      } else {
        var wrap = document.createElement('div');
        wrap.style.marginTop = '6px';
        wrap.appendChild(createLink(isbn, finalUrl, IMG_HEIGHT_BLOCK));
        (pointBox || pointRow.parentElement || pointRow).insertAdjacentElement('afterend', wrap);
      }
      return;
    }

    // 未ログイン時
    var priceAnchor = findPriceAnchor();
    if (priceAnchor) {
      var holder = document.createElement('div');
      holder.id = 'honto-ebook-link-holder';
      holder.style.margin = PRICE_GAP_PX + 'px 0 0 0';
      holder.appendChild(createLink(isbn, finalUrl, IMG_HEIGHT_BLOCK));
      priceAnchor.insertAdjacentElement('afterend', holder);
      return;
    }

    // 価格が取れないケース
    var addBtn = findAddButton();
    if (addBtn) {
      var holder2 = document.createElement('div');
      holder2.id = 'honto-ebook-link-holder';
      holder2.style.margin = '6px 0';
      holder2.appendChild(createLink(isbn, finalUrl, IMG_HEIGHT_BLOCK));
      addBtn.insertAdjacentElement('beforebegin', holder2);
    }
  }

  function run() {
    if (IS_BOT) return;
    var path = location.pathname.replace(/\/+$/, '');
    var m = path.match(/^\/products\/(\d{13})(?:$|\/)/);
    if (!m) return;
    var code = m[1];

    // 9784（書籍ISBN-13）or 491（雑誌JAN）
    if (!/^(9784\d{9}|491\d{10})$/.test(code)) return;

    if (document.getElementById('honto-ebook-link')) return;

    fetch('https://ebook.maruzenjunkudo.co.jp/?isbn=' + code, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.exists) return;
        insertLink(code, d.finalUrl || null);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
